module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/faq_hairmakeup_02-752fabcc1033b4795bb26a517b04ea0c.png";